import { SVGProps } from 'react'

const SvgDrawPolygon = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox='0 0 512 512' xmlns='http://www.w3.org/2000/svg' {...props}>
    <path d='M416.3 352c35.2.2 63.7 28.7 63.7 64s-28.7 64-64 64c-23.7 0-44.4-12.9-55.4-32H151.4c-11 19.1-31.71 32-55.4 32-35.35 0-64-28.7-64-64 0-23.7 12.87-44.4 32-55.4V151.4c-19.13-11-32-31.7-32-55.4 0-35.35 28.65-64 64-64 23.69 0 44.4 12.87 55.4 32h209.2c11-19.13 31.7-32 55.4-32 35.3 0 64 28.65 64 64 0 35.3-28.5 63.8-63.7 63.1l-38.8 68.8c4.2 8.5 6.5 18 6.5 28.1s-2.3 19.6-6.5 28.1zM128 360.6c9.7 5.6 17.8 13.7 23.4 23.4h209.2c0-.1.1-.2.1-.3l-36.5-63.8c-1.4-.8-2.8.1-4.2.1-35.3 0-64-28.7-64-64s28.7-64 64-64c1.4 0 2.8 0 4.2.1l36.5-63.8-.1-.3H151.4c-5.6 9.7-13.7 17.8-23.4 23.4z' />
  </svg>
)

export default SvgDrawPolygon
